export default __webpack_public_path__ + "static/media/Image 1.999eee42.png";